module.exports = __webpack_public_path__ + "32019470b8610163781171d6b9343f34.ttf";